import { LogLevel } from '@azure/msal-browser';
import { AZURE_ID, AZURE_HOST, AZURE_TENANT_ID, REDIRECT_URI} from '../src/config/env';

export const msalConfig = {
  auth: {
    clientId:`${AZURE_ID}`,
    authority:`https://login.microsoftonline.com/${AZURE_TENANT_ID}`,
    redirectUri:REDIRECT_URI,
    postLogoutRedirectUri:'/',
  },
  cache: {
    cacheLocation:'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback:(level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        console.log(`[${level}] ${message}`);
      },
    },
  },
};

export const loginRequest = {
  scopes:['User.Read', 'profile', 'openid', 'email'],
  forceRefresh: true,
};

export const graphConfig = {
  graphMeEndpoint:'https://graph.microsoft.com/v1.0/me',
  forceRefresh: true,
};